import styled, { css } from "styled-components";
import { ReactComponent as CreateIc } from "assets/icons/create.svg";

type ShowTourProps = {
  showTour: false;
};

export const Container = styled.div<ShowTourProps>`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      background-color: #ffff;
      padding: 4px;
      border-radius: 8px;
    `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const BoxPadding = styled.div`
  padding: 0px 20px;
`;

export const HeaderPage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 10px 0px 20px 0px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #262626;
  font-weight: bold;

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const EditIcon = styled(CreateIc)`
  margin-right: 6px;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 24px;
  height: 24px;
  width: 24px;
  path:nth-child(2) {
    fill: ${({ theme }) => theme.colors.gray};
  }
`;

export const PanelHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(38px, auto));
  column-gap: 20px;
  justify-content: space-between;
  margin-bottom: 43px;
`;

export const CondoIconContainer = styled.div`
  width: 57px;
  height: 57px;
  border-radius: 100%;
  background-color: #f2f2f2;
  display: flex;
  place-content: center;
  place-items: center;
`;
export const InfoContainer = styled.div``;
export const Label = styled.span`
  color: #757575;
  font-size: 0.9375rem;
  font-weight: bold;
`;
export const Info = styled.div`
  color: #757575;
  font-size: 0.9375rem;
  font-weight: 400;
`;

export const PanelBilling = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(38px, auto));
  column-gap: 20px;
  justify-content: space-between;
  margin-bottom: 39px;
`;

export const PanelDA = styled.div``;

export const EditIconContainer = styled.div`
  cursor: pointer;
`;
